import { CardHeader, CardTitle, Col, Container, FormGroup, Label, Table, Card, CardBody, Button, Form, Row, Spinner, UncontrolledCollapse, Modal, ModalHeader, ModalBody, ModalFooter, Tooltip } from "reactstrap";
import Header from "../UI/Header";
import HeaderTitle from "../UI/HeaderTitle";
import HeaderSubtitle from "../UI/HeaderSubtitle";
import useError from "../../hooks/useError";
import { useProfileContext } from "../../context/profile";
import { useDebounce } from "use-debounce";
import instance from "../../axiosInstance";
import React, { useEffect, useState } from "react";
import moment from "moment";
import Pagination from "../UI/Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faDownload, faSort, faSortDown, faSortUp, faFolderOpen, faHardDrive } from "@fortawesome/free-solid-svg-icons";
import CustomDate, { months, years } from "../UI/forms/CustomDate";
import { AsyncPaginate } from "react-select-async-paginate";
import TableFeedback from "../UI/TableFeedback";
import { toDateObj, toYYYYMMDD } from "../../utils/forms";
import { Link } from "react-router-dom";
import { useHistory, useLocation } from "react-router-dom";
import { Check, X, Link as LinkIcon, Image as ImageIcon } from "react-feather";
import JSZip from "jszip";
import Chart from 'react-apexcharts';
import ParamsLink from "../UI/links/ParamsLink";
import Select from "react-select";

export const selectHideArrowStyle = {
    dropdownIndicator: (base) => ({
        ...base,
        display: "none",
    }),
    indicatorSeparator: (base) => ({
        ...base,
        display: "none",
    }),
};

const SolicitorDashboard = ({ theme }) => {
    const { handleError } = useError();
    const { profile } = useProfileContext();
    const [newCases, setNewCases] = useState([]);
    const [paginationInfo, setPaginationInfo] = useState({
        currentPage: 0,
        totalPages: 0,
        totalRecords: 0,
        limit: 0,
    });

    // Column filter states
    const [filters, setFilters] = useState({
        case_id: '',
        client_name: '',
        solicitor_reference: '',
        case_type: '',
        current_status: '',
        paid_date: ''
    });

    const [tooltipOpen, setTooltipOpen] = useState(false);
    const toggle = () => setTooltipOpen(!tooltipOpen);

    const [attachmentsModal, setAttachmentsModal] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [userAttachments, setUserAttachments] = useState([]);
    const [loadingAttachments, setLoadingAttachments] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const history = useHistory();
    const location = useLocation();

    // Query Parameters and Debounce
    const queryParams = new URLSearchParams(location.search);
    const page = parseInt(queryParams.get("page")) || 1;
    const limit = parseInt(queryParams.get("limit")) || 50;

    // Filter states
    const [sort_column, setSortColumn] = useState(null);
    const [sort_direction, setSortDirection] = useState(null);
    const [from_created_date, setFromCreatedDate] = useState(null);
    const [to_created_date, setToCreatedDate] = useState(null);
    const [current_status, setCurrentStatus] = useState(null);
    const [lead_source_id, setLeadSourceId] = useState(null);
    const [solicitor_id, setSolicitorId] = useState(null);
    const [file_handler_id, setFileHandlerId] = useState(null);
    const [introducer_id, setIntroducerId] = useState(null);

    const [selectedImage, setSelectedImage] = useState(null);
    const [imagePreviewModal, setImagePreviewModal] = useState(false);


    let fetchedCurrentStatusOptions = [];
    const fetchCurrentStatusOptions = async (search) => {
        try {
            if (search && fetchedCurrentStatusOptions.length) {
                const filteredOptions = fetchedCurrentStatusOptions.filter((option) => option.label.toLowerCase().includes(search.toLowerCase()));
                return {
                    options: filteredOptions,
                    hasMore: false,
                };
            }

            const res = await instance.get("/lookups/caseStatus");
            const { data } = res.data;
            const options = data.map((status) => ({
                value: status,
                label: status,
            }));

            fetchedCurrentStatusOptions = options;

            return {
                options,
                hasMore: false,
            };
        } catch (error) {
            return {
                options: [],
                hasMore: false,
            };
        }
    };

    let fetchedCaseTypeOptions = [];
    const fetchCaseTypeOptions = async (search) => {
        try {
            if (search && fetchedCaseTypeOptions.length) {
                const filteredOptions = fetchedCaseTypeOptions.filter((option) => option.label.toLowerCase().includes(search.toLowerCase()));
                return {
                    options: filteredOptions,
                    hasMore: false,
                };
            }

            const res = await instance.get("/lookups/caseTypes");
            const { data } = res.data;
            const options = data.map((type) => ({
                value: type,
                label: type,
            }));

            fetchedCaseTypeOptions = options;

            return {
                options,
                hasMore: false,
            };
        } catch (error) {
            return {
                options: [],
                hasMore: false,
            };
        }
    };

    const getNewCases = async () => {
        try {
            setIsLoading(true);
            const res = await instance.get("/dashboard/solicitorCaseList", {
                params: {
                    page,
                    limit,
                    sort_column,
                    sort_direction,
                    from_date: toYYYYMMDD(from_created_date),
                    to_date: toYYYYMMDD(to_created_date),
                    lead_source_id: lead_source_id ? lead_source_id.value : null,
                    solicitor_id: solicitor_id ? solicitor_id.value : null,
                    current_status: current_status ? current_status.value : null,
                    file_handler_id: file_handler_id ? file_handler_id.value : null,
                    introducer_id: introducer_id ? introducer_id.value : null,
                    filters: filters
                },
            });

            const data = res.data.data;
            setNewCases(data.data);
            setPaginationInfo({
                currentPage: data.page,
                totalPages: data.total_pages,
                totalRecords: data.total_records,
                limit: data.limit,
            });
        } catch (error) {
            handleError(error);
        } finally {
            setIsLoading(false);
        }
    };

    const exportHandler = async () => {
        try {
            setIsDownloading(true);
            const res = await instance.get("/dashboard/solicitorCaseList", {
                params: {
                    sort_column,
                    sort_direction,
                    from_date: toYYYYMMDD(from_created_date),
                    to_date: toYYYYMMDD(to_created_date),
                    page,
                    limit: 50,
                    lead_source_id: lead_source_id ? lead_source_id.value : null,
                    solicitor_id: solicitor_id ? solicitor_id.value : null,
                    current_status: current_status ? current_status.value : null,
                    file_handler_id: file_handler_id ? file_handler_id.value : null,
                    introducer_id: introducer_id ? introducer_id.value : null,
                    export_excel: 1,
                },
            });

            const fileUrl = res.data.data.file_url;
            const link = document.createElement("a");
            link.href = fileUrl;
            link.setAttribute("download", "solicitor_dashboard.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setIsDownloading(false);
        } catch (error) {
            setIsDownloading(false);
            handleError(error);
        }
    };

    const handleFilterChange = (column, value) => {
        setFilters(prev => ({
            ...prev,
            [column]: value
        }));
    };

    // Debounce filter changes
    const [debouncedFilters] = useDebounce(filters, 500);

    useEffect(() => {
        getNewCases();
    }, [page, sort_column, sort_direction, debouncedFilters]);

    const [dashboardInfo, setDashboardInfo] = useState(null);
    const [dashboardLoading, setDashboardLoading] = useState(false);
    const [valuesCases, setValuesCases] = useState([]);
    const [categoriesCases, setCategoriesCases] = useState([]);
    const [chartOptionsCases, setChartOptionsCases] = useState({});
    const [chartSeriesCases, setChartSeriesCases] = useState([]);

    const date = new Date();

    const [useMonthYear, setUseMonthYear] = useState(true);

    const selectedYear = sessionStorage.getItem("admin-selectedYear") || date.getFullYear();
    const selectedMonth = sessionStorage.getItem("admin-selectedMonth") || date.getMonth() + 1;

    const [month, setMonth] = useState({ value: date.getMonth() + 1, label: months[date.getMonth()] });
    const [year, setYear] = useState(selectedYear ? { value: selectedYear, label: selectedYear } : { value: date.getFullYear(), label: date.getFullYear() });
    const [fromDate, setFromDate] = useState(new Date(moment().startOf('month')));
    const [toDate, setToDate] = useState(new Date());

    useEffect(() => {
        (async function () {
            try {
                setDashboardLoading(true);
                const { data } = await instance.get("/dashboard/solicitor", {
                    params: useMonthYear ? {
                        current_year: year?.value || null,
                        current_month: month?.value || null,
                        month_year: true
                    } : {
                        from_date: moment(fromDate).format('YYYY-MM-DD'),
                        to_date: moment(toDate).format('YYYY-MM-DD'),
                        month_year: false
                    },
                });
                setDashboardInfo(data.data);
                setDashboardLoading(false);
            } catch (error) {
                handleError(error);
                setDashboardLoading(false);
            }
        })();
    }, [month?.value, year?.value, fromDate, toDate]);

    useEffect(() => {
        if (dashboardInfo) {
            // Case Statistics
            const categoriesCases = Object.keys(dashboardInfo.solicitorClaimCases);
            const valuesCases = Object.values(dashboardInfo.solicitorClaimCases);
            setCategoriesCases(categoriesCases);
            setValuesCases(valuesCases);

            const chartOptionsCases = {
                chart: {
                    type: 'bar',
                    height: 350,
                    toolbar: { show: false },
                    animations: {
                        enabled: true,
                        easing: 'easeinout',
                        speed: 800
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        borderRadius: 4,
                        columnWidth: '60%',
                    }
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        fontSize: '12px',
                        colors: ['#ffffff'],
                        fontWeight: 600
                    }
                },
                xaxis: {
                    categories: categoriesCases
                },
                colors: ['#36b9cc']
            };

            const chartSeriesCases = [
                {
                    name: 'Cases',
                    data: valuesCases
                }
            ];
            setChartOptionsCases(chartOptionsCases);
            setChartSeriesCases(chartSeriesCases);
        }
    }, [dashboardInfo]);

    const getSortIcon = (column) => {
        if (sort_column === column) {
            return sort_direction === "asc" ? <FontAwesomeIcon icon={faSortUp} /> : <FontAwesomeIcon icon={faSortDown} />;
        }
        return <FontAwesomeIcon icon={faSort} />;
    };

    const handleSort = (column) => {
        setSortColumn(column);
        setSortDirection(sort_column === column && sort_direction === "asc" ? "desc" : "asc");
    };

    const fetchUserAttachments = async (caseId) => {
        try {
            setLoadingAttachments(true);
            const response = await instance.get(`/lookups/caseAttachment`, {
                params: { case_id: caseId }
            });
            setUserAttachments(response.data.data || []);
        } catch (error) {
            handleError(error);
        } finally {
            setLoadingAttachments(false);
        }
    };

    const handleViewAttachments = (userId) => {
        setSelectedUserId(userId);
        setAttachmentsModal(true);
        fetchUserAttachments(userId);
    };

    const handleDownloadAttachment = (file) => {
        window.open(file, '_blank');
    };

    const handleImageClick = (imageUrl) => {
        setSelectedImage(imageUrl);
        setImagePreviewModal(true);
    };

    const [zipDownloadLoader, setZipDownloadLoader] = useState(false);



    return (
        <Container fluid>
            <Header>
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <HeaderTitle>Welcome, {profile?.full_name}</HeaderTitle>
                        <HeaderSubtitle>
                            <span className="fs-18">Total Cases:</span> <span className="fs-22">{dashboardInfo?.total_cases || 0}</span>
                        </HeaderSubtitle>
                    </div>
                    <div className="position-absolute top-0 right-0" style={{ right: '10px' }}>
                        <div className="d-flex align-items-center mb-3">
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    checked={!useMonthYear}
                                    onChange={(e) => setUseMonthYear(!useMonthYear)}
                                />
                                <span className="slider round">
                                    <span className="slider-text left">Month/Year</span>
                                    <span className="slider-text right">Date Range</span>
                                </span>
                            </label>
                            {dashboardLoading && (
                                <div className="mx-3">
                                    <Spinner size="sm" color="primary" />
                                </div>
                            )}
                        </div>

                        <div className="d-flex" style={{ minHeight: '38px', width: '340px' }}>
                            <div style={{ width: '160px', marginRight: '12px' }}>
                                {useMonthYear ? (
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        placeholder="Month"
                                        isClearable
                                        styles={selectHideArrowStyle}
                                        value={month}
                                        onChange={(selectedOption) => {
                                            setMonth(selectedOption);
                                            selectedOption ? sessionStorage.setItem("admin-selectedMonth", selectedOption.value) : sessionStorage.removeItem("admin-selectedMonth");
                                        }}
                                        options={months.map((month, index) => ({ value: index + 1, label: month }))}
                                    />
                                ) : (
                                    <FormGroup className="mb-0">
                                        <CustomDate
                                            startDate={fromDate}
                                            setStartDate={setFromDate}
                                            id="fromDate"
                                            placeholder="From Date"
                                        />
                                    </FormGroup>
                                )}
                            </div>
                            <div style={{ width: '160px' }}>
                                {useMonthYear ? (
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        placeholder="Year"
                                        styles={selectHideArrowStyle}
                                        value={year}
                                        onChange={(selectedOption) => {
                                            setYear(selectedOption);
                                            selectedOption ? sessionStorage.setItem("admin-selectedYear", selectedOption.value) : sessionStorage.removeItem("admin-selectedYear");
                                        }}
                                        options={years.map((year) => ({ value: year, label: year }))}
                                    />
                                ) : (
                                    <FormGroup className="mb-0">
                                        <CustomDate
                                            startDate={toDate}
                                            setStartDate={setToDate}
                                            id="toDate"
                                            placeholder="To Date"
                                        />
                                    </FormGroup>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Header>

            <Col lg={12} md={12} className="mb-4">
                <Card className="border-0 shadow-sm h-100">
                    <CardBody className="p-4">
                        <div className="d-flex align-items-center mb-4">
                            <div className="flex-shrink-0 me-3 mr-3">
                                <div className="bg-info bg-opacity-10 p-3 rounded-circle">
                                    <FontAwesomeIcon icon={faHardDrive} className="text-light fa-lg" />
                                </div>
                            </div>
                            <div>
                                <h4 className="mb-0 fw-bold">Case Statistics</h4>
                            </div>
                        </div>
                        <div className="chart-container position-relative mb-4">
                            <Chart
                                options={{
                                    ...chartOptionsCases,
                                    chart: {
                                        ...chartOptionsCases.chart,
                                        background: 'transparent',
                                        fontFamily: 'inherit',
                                        toolbar: { show: false },
                                        animations: {
                                            enabled: true,
                                            easing: 'easeinout',
                                            speed: 800
                                        }
                                    },
                                    colors: ['#36b9cc'],
                                    grid: {
                                        borderColor: '#f1f1f1',
                                        strokeDashArray: 4,
                                        padding: { top: 0, right: 0, bottom: 0, left: 0 }
                                    },
                                    dataLabels: {
                                        enabled: true,
                                        style: {
                                            fontSize: '12px',
                                            colors: ['#ffffff'],
                                            fontWeight: 600
                                        }
                                    },
                                    plotOptions: {
                                        bar: {
                                            borderRadius: 4,
                                            columnWidth: '60%',
                                        }
                                    }
                                }}
                                series={chartSeriesCases}
                                type="bar"
                                height={280}
                            />
                        </div>
                        <div className="table-responsive">
                            <table className="table table-sm align-middle mb-0">
                                <thead>
                                    <tr>
                                        <th className="text-muted small text-uppercase fw-bold">Case Type</th>
                                        <th className="text-right text-muted small text-uppercase fw-bold">No. of Cases</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {categoriesCases.map((cat, index) => (
                                        <tr key={index}>
                                            <td className="fw-medium">{cat}</td>
                                            <td className="text-right fw-bold text-info">{valuesCases[index]}</td>
                                        </tr>
                                    ))}
                                    <tr>
                                        <td className="fw-medium">Total</td>
                                        <td className="text-right fw-bold text-primary">{valuesCases.reduce((acc, curr) => parseInt(acc) + parseInt(curr), 0)}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </CardBody>
                </Card>
            </Col>

            <Col lg={12} md={12} className="mb-4">
                <Card className="custom-table-2">
                    <CardHeader>
                        <CardTitle tag="h5" className="my-2 d-flex align-items-center justify-content-between">
                            <Link id="repairFilters" className="custom-link w-100" to={`#repairFilters`} onClick={() => setIsOpen((pre) => !pre)}>
                                <FormGroup check className="mb-2">
                                    <div check className="d-flex align-items-center">
                                        Filters
                                        <FontAwesomeIcon icon={faArrowRight} className={`ml-2 ${isOpen ? "rotate-90" : "rotate-0"}`} />
                                    </div>
                                </FormGroup>
                            </Link>
                            <Button color="primary" className="d-flex align-items-center" disabled={isDownloading} onClick={exportHandler}>
                                {isDownloading ? "Exporting..." : "Export"} <FontAwesomeIcon icon={faDownload} className="ml-2" />
                            </Button>
                        </CardTitle>
                    </CardHeader>
                    <UncontrolledCollapse className="custom-filter-2" toggler={`#repairFilters`}>
                        <CardBody>
                            <Form>
                                <Row>
                                    <Col md={3}>
                                        <FormGroup>
                                            <Label for="caseOpenFrom">Case Open From</Label>
                                            <Col md={12} className="p-0 w-100">
                                                <CustomDate className="w-100" startDate={from_created_date} setStartDate={(date) => setFromCreatedDate(date)} id="caseOpenFrom" />
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                    <Col md={3}>
                                        <FormGroup>
                                            <Label for="caseOpenTo">Case Open To</Label>
                                            <Col md={12} className="p-0 w-100">
                                                <CustomDate className="w-100" startDate={to_created_date} setStartDate={(date) => setToCreatedDate(date)} id="caseOpenTo" />
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <div className="d-flex justify-content-center mt-4">
                                    <Button color="primary" onClick={getNewCases}>
                                        Filter
                                    </Button>
                                </div>
                            </Form>
                        </CardBody>
                    </UncontrolledCollapse>
                    <div style={{ height: "65vh", display: "flex", flexDirection: "column", justifyContent: "space-between", marginBottom: "50px" }}>
                        <Table responsive striped className="mt-0">
                            <thead>
                                <tr>
                                    <th scope="col">Sr.</th>
                                    <th scope="col" className="cursor-pointer" onClick={() => handleSort("solicitor_reference")}>
                                        Solicitor Reference {getSortIcon("solicitor_reference")}
                                    </th>
                                    <th scope="col" className="cursor-pointer" onClick={() => handleSort("case_id")}>
                                        Case ID {getSortIcon("case_id")}
                                    </th>
                                    <th scope="col" className="cursor-pointer min-w-130" onClick={() => handleSort("client_name")}>
                                        Client Name {getSortIcon("client_name")}
                                    </th>
                                    <th scope="col" className="cursor-pointer min-w-130" onClick={() => handleSort("case_type")}>
                                        Case Type {getSortIcon("case_type")}
                                    </th>
                                    <th scope="col" className="cursor-pointer min-w-130" onClick={() => handleSort("current_status")}>
                                        Status {getSortIcon("current_status")}
                                    </th>
                                    <th scope="col" className="cursor-pointer min-w-130" onClick={() => handleSort("paid_date")}>
                                        Paid Date {getSortIcon("paid_date")}
                                    </th>
                                    <th scope="col">Attachments</th>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            placeholder="Filter Reference"
                                            value={filters.solicitor_reference}
                                            onChange={(e) => handleFilterChange('solicitor_reference', e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            placeholder="Filter Case ID"
                                            value={filters.case_id}
                                            onChange={(e) => handleFilterChange('case_id', e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            placeholder="Filter Client Name"
                                            value={filters.client_name}
                                            onChange={(e) => handleFilterChange('client_name', e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <AsyncPaginate
                                            className="basic-single"
                                            classNamePrefix="select"
                                            isSearchable
                                            name="caseType"
                                            loadOptions={fetchCaseTypeOptions}
                                            additional={{
                                                page: 1,
                                            }}
                                            isClearable
                                            styles={{
                                                menu: (base) => ({
                                                    ...base,
                                                    maxHeight: 150,
                                                    overflowY: 'auto',
                                                    scrollBehavior: 'smooth',
                                                    WebkitOverflowScrolling: 'touch',
                                                }),
                                                menuList: (base) => ({
                                                    ...base,
                                                    maxHeight: 150,
                                                    overflowY: 'auto',
                                                }),
                                            }}
                                            debounceTimeout={300}
                                            value={filters.case_type}
                                            onChange={(value) => handleFilterChange('case_type', value)}
                                            placeholder="Filter Case Type"
                                        />
                                    </td>
                                    <td>
                                        <AsyncPaginate
                                            className="basic-single"
                                            classNamePrefix="select"
                                            isSearchable
                                            name="currentStatus"
                                            loadOptions={fetchCurrentStatusOptions}
                                            additional={{
                                                page: 1,
                                            }}
                                            isClearable
                                            styles={{
                                                menu: (base) => ({
                                                    ...base,
                                                    maxHeight: 150,
                                                    overflowY: 'auto',
                                                    scrollBehavior: 'smooth',
                                                    WebkitOverflowScrolling: 'touch',
                                                }),
                                                menuList: (base) => ({
                                                    ...base,
                                                    maxHeight: 150,
                                                    overflowY: 'auto',
                                                }),
                                            }}
                                            debounceTimeout={300}
                                            value={filters.current_status}
                                            onChange={(value) => handleFilterChange('current_status', value)}
                                            placeholder="Filter Status"
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            placeholder="Filter Paid Date"
                                            value={filters.paid_date}
                                            onChange={(e) => handleFilterChange('paid_date', e.target.value)}
                                        />
                                    </td>
                                    <td></td>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading && (
                                    <tr>
                                        <td colSpan="100" className="text-center">
                                            <Spinner color="primary" style={{ width: "2rem", height: "2rem" }} />
                                        </td>
                                    </tr>
                                )}
                                {newCases.length === 0 && !isLoading && <TableFeedback message="No cases found!" colSpan="100" />}
                                {newCases.map((item) => (
                                    <tr key={item.case_id}>
                                        <td>{item.sr}</td>
                                        <td>{item.solicitor_reference}</td>
                                        <td>
                                            <ParamsLink to={`/administration/cases/view/${item.case_id}`}>
                                                {item.case_id}
                                            </ParamsLink>
                                        </td>
                                        <td className="">{item.client_name || "-"}</td>
                                        <td className="">{item.case_type || "-"}</td>
                                        <td className="">{item.current_status || "-"}</td>
                                        <td className="">{item.paid_date || "-"}</td>
                                        <td>
                                            <span
                                                id="linkIconTooltip"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => handleViewAttachments(item.case_id)}
                                            >
                                                <LinkIcon size={18} />
                                            </span>

                                            <Tooltip
                                                placement="top"
                                                isOpen={tooltipOpen}
                                                target="linkIconTooltip"
                                                toggle={toggle}
                                            >
                                                View Attachments
                                            </Tooltip>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <div style={{ background: 'white', padding: '10px', borderRadius: '5px', marginBottom: '50px' }}>
                            <Pagination paginationInfo={paginationInfo} />
                        </div>
                    </div>
                </Card>
            </Col>

            <Modal isOpen={attachmentsModal} toggle={() => setAttachmentsModal(false)} size="lg" className="attachments-modal">
                <ModalHeader toggle={() => setAttachmentsModal(false)} className="bg-light border-bottom-0">
                    <div className="d-flex align-items-center">
                        <FontAwesomeIcon icon={faFolderOpen} className="text-primary mr-2" />
                        <h5 className="mb-0">Case Attachments</h5>
                    </div>
                </ModalHeader>
                <ModalBody style={{ maxHeight: '70vh', overflowY: 'auto' }} className="px-4">
                    {loadingAttachments ? (
                        <div className="text-center py-5">
                            <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
                            <p className="mt-3 text-muted">Loading attachments...</p>
                        </div>
                    ) : userAttachments.length > 0 ? (
                        <>
                            <div className="mb-4 d-flex justify-content-between align-items-center">
                                <div className="text-muted">
                                    <small>Total Files: {userAttachments.length}</small>
                                </div>
                                {userAttachments.length > 0 && (
                                    <Button
                                        loading={zipDownloadLoader}
                                        disabled={zipDownloadLoader}
                                        color="success"
                                        className="d-flex align-items-center shadow-sm"
                                        onClick={async () => {
                                            try {
                                                const zip = new JSZip();
                                                setZipDownloadLoader(true);
                                                const downloadPromises = userAttachments.map(async (attachment) => {
                                                    const response = await fetch(attachment.href);
                                                    const blob = await response.blob();
                                                    zip.file(attachment.file, blob);
                                                });

                                                await Promise.all(downloadPromises);
                                                const content = await zip.generateAsync({ type: "blob" });
                                                const link = document.createElement('a');
                                                link.href = URL.createObjectURL(content);
                                                link.download = "attachments.zip";
                                                document.body.appendChild(link);
                                                link.click();
                                                document.body.removeChild(link);
                                                URL.revokeObjectURL(link.href);
                                                setZipDownloadLoader(false);
                                            } catch (error) {
                                                handleError(error);
                                                setZipDownloadLoader(false);
                                            }
                                        }}
                                    >
                                        {zipDownloadLoader ? (
                                            <>
                                                <Spinner size="sm" color="#fff" className="mr-2" style={{ borderWidth: "0.12em", width: "0.8rem", height: "0.8rem" }} />
                                                <span>Preparing Download...</span>
                                            </>
                                        ) : (
                                            <>
                                                <FontAwesomeIcon icon={faDownload} className="mr-2" />
                                                <span>Download All (.zip)</span>
                                            </>
                                        )}
                                    </Button>
                                )}
                            </div>
                            <div className="table-responsive">
                                <Table hover className="attachments-table mb-0">
                                    <thead>
                                        <tr className="bg-light">
                                            <th className="py-3 px-3 border-0">Title</th>
                                            <th className="py-3 px-3 border-0">File</th>
                                            <th className="py-3 px-3 border-0 text-center" style={{ width: '100px' }}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {userAttachments.map((attachment, index) => (
                                            <tr key={index} className="border-bottom">
                                                <td className="py-3 px-3 align-middle">
                                                    <span className="font-weight-medium">{attachment.title}</span>
                                                </td>
                                                <td
                                                    className="py-3 px-3 align-middle"
                                                    onClick={() => { attachment.file_type == "image" ? handleImageClick(attachment.href) : window.open(attachment.href, "_blank") }}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <div className="d-flex align-items-center">
                                                        <span className="text-primary text-truncate" style={{ maxWidth: '300px' }}>{attachment.file}</span>
                                                        {attachment.file_type == "image" && (
                                                            <div className="ml-2 position-relative image-preview">
                                                                <img
                                                                    src={attachment.href}
                                                                    alt="Preview"
                                                                    style={{
                                                                        width: "32px",
                                                                        height: "32px",
                                                                        objectFit: "cover",
                                                                        borderRadius: "4px",
                                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                                <td className="py-3 px-3 align-middle text-center">
                                                    <Button
                                                        color="primary"
                                                        size="sm"
                                                        className="px-3 shadow-sm"
                                                        onClick={() => handleDownloadAttachment(attachment.href)}
                                                    >
                                                        <FontAwesomeIcon icon={faDownload} />
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </>
                    ) : (
                        <div className="text-center py-5">
                            <div className="mb-4">
                                <FontAwesomeIcon icon={faFolderOpen} size="3x" className="text-muted" />
                            </div>
                            <h5 className="text-muted mb-2">No Attachments Found</h5>
                            <p className="text-muted mb-0">There are no attachments available for this case.</p>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter className="bg-light border-top-0">
                    <Button
                        color="secondary"
                        onClick={() => setAttachmentsModal(false)}
                        className="px-4 shadow-sm"
                    >
                        Close
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal
                isOpen={imagePreviewModal}
                toggle={() => setImagePreviewModal(false)}
                className="image-preview-modal"
                size="xl"
                centered
            >
                <ModalBody className="p-0 position-relative">
                    <Button
                        className="position-absolute"
                        style={{
                            top: '10px',
                            right: '10px',
                            zIndex: 1000,
                            background: 'rgba(0,0,0,0.5)',
                            border: 'none'
                        }}
                        onClick={() => setImagePreviewModal(false)}
                    >
                        <X size={24} color="white" />
                    </Button>
                    {selectedImage && (
                        <img
                            src={selectedImage}
                            alt={<ImageIcon size={24} />}
                            style={{
                                width: '100%',
                                height: 'auto',
                                maxHeight: '90vh',
                                objectFit: 'contain'
                            }}
                        />
                    )}
                </ModalBody>
            </Modal>

            <style>
                {`
                .image-custom-modal .modal-content{
                    background: transparent !important;
                }
                .close-button {
                    position: absolute;
                    bottom: 20px;
                    right: 50%;
                    z-index: 1000;
                    background: rgba(0, 0, 0, 0.5);
                    border: none;
                    color: white;
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: background 0.3s;
                }
                .close-button:hover {
                    background: rgba(0, 0, 0, 0.7);
                }
                .attachments-modal .modal-content {
                    border: none;
                    border-radius: 8px;
                    box-shadow: 0 4px 20px rgba(0,0,0,0.1);
                }

                .attachments-modal .modal-header {
                    border-radius: 8px 8px 0 0;
                    padding: 1.25rem 1.5rem;
                }

                .attachments-modal .modal-body {
                    padding: 1.5rem;
                }

                .attachments-modal .modal-footer {
                    border-radius: 0 0 8px 8px;
                    padding: 1rem 1.5rem;
                }

                .attachments-table th {
                    font-weight: 600;
                    color: #495057;
                }

                .attachments-table td {
                    transition: background-color 0.2s ease;
                }

                .attachments-table tr:hover td {
                    background-color: #f8f9fa;
                }

                .attachments-modal .btn {
                    transition: all 0.2s ease;
                }

                .attachments-modal .btn:hover {
                    transform: translateY(-1px);
                }

                .attachments-modal .btn:active {
                    transform: translateY(0);
                }

                .attachments-modal .table-responsive {
                    border-radius: 6px;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
                }

                .attachments-modal .text-primary {
                    color: #2196F3 !important;
                }

                .attachments-modal .text-muted {
                    color: #6c757d !important;
                }

                .image-preview-modal .modal-content {
                    background: transparent;
                    border: none;
                    box-shadow: none;
                }

                .image-preview-modal .modal-body {
                    padding: 0;
                    background: transparent;
                }

                .image-preview-modal .btn {
                    padding: 8px;
                    border-radius: 50%;
                    transition: all 0.2s ease;
                }

                .image-preview-modal .btn:hover {
                    background: rgba(0,0,0,0.7);
                    transform: scale(1.1);
                }

                .attachments-table td .image-preview {
                    position: relative;
                    cursor: pointer;
                    transition: all 0.2s ease;
                }

                .attachments-table td .image-preview:hover {
                    transform: scale(1.1);
                }

                .attachments-table td .image-preview::after {
                    content: '👁️';
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    opacity: 0;
                    transition: opacity 0.2s ease;
                    font-size: 14px;
                    background: rgba(0,0,0,0.5);
                    color: white;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 4px;
                }

                .table-responsive{
                    height: auto !important;
                    max-height: max-content !important;
                    min-height: 65vh !important;
                }

                .switch {
                    position: relative;
                    display: inline-block;
                    width: 106px;
                    height: 28px;
                }

                .switch input {
                    opacity: 0;
                    width: 0;
                    height: 0;
                }

                .slider {
                    position: absolute;
                    cursor: pointer;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-color: #ccc;
                    transition: .4s;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 4px;
                }

                .slider::before {
                    position: absolute;
                    content: "";
                    height: 23px !important;
                    width: 23px !important;
                    left: 2px;
                    bottom: 2px;
                    background-color: white;
                    transition: .4s;
                    z-index: 2;
                    box-shadow: 0 0 2px rgba(0,0,0,0.2);
                }

                .slider-text {
                    font-size: 10px;
                    font-weight: 500;
                    color: white;
                    position: absolute;
                    transition: .4s;
                    user-select: none;
                    width: 85px;
                    text-align: center;
                }

                .slider-text.left {
                    right: 1px;
                }

                .slider-text.right {
                    left: 1px;
                }

                input:not(:checked) + .slider .slider-text.left {
                    opacity: 1;
                }

                input:checked + .slider .slider-text.right {
                    opacity: 1;
                }

                input:not(:checked) + .slider .slider-text.right {
                    opacity: 0;
                }

                input:checked + .slider .slider-text.left {
                    opacity: 0;
                }

                input:checked + .slider {
                    background-color: #2196F3;
                }

                input:focus + .slider {
                    box-shadow: 0 0 1px #2196F3;
                }

                input:checked + .slider:before {
                    transform: translateX(78px);
                }

                .slider.round {
                    border-radius: 34px;
                }

                .slider.round:before {
                    border-radius: 50%;
                }

                .status-label {
                    font-size: 13px;
                    font-weight: 500;
                    color: #6c757d;
                    margin-left: 8px;
                    user-select: none;
                }
                `}
            </style>
        </Container>
    );
};

export default SolicitorDashboard;